var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.176,
    height: 14.154,
    viewBox: "0 0 16.176 14.154",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-from-bracket-solid",
    d: "M5.055,44.132H3.033a1.011,1.011,0,0,1-1.011-1.011V35.033a1.011,1.011,0,0,1,1.011-1.011H5.055a1.011,1.011,0,1,0,0-2.022H3.033A3.033,3.033,0,0,0,0,35.033v8.088a3.033,3.033,0,0,0,3.033,3.033H5.055a1.011,1.011,0,1,0,0-2.022Zm10.824-5.769-4.044-4.044a1.011,1.011,0,0,0-1.43,1.43l2.321,2.317H6.066a1.011,1.011,0,1,0,0,2.022h6.66l-2.318,2.318a1.011,1.011,0,1,0,1.43,1.43l4.044-4.044A1.012,1.012,0,0,0,15.879,38.363Z",
    transform: "translate(0 -32)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.2d32936485f8c797480fb1f535c88006.svg";